export default __webpack_public_path__ + "static/media/event-wall-4.b0643c35.jpg";